import { ValueObject } from '@nx-smartmonkey/shared/domain';
import { ProjectDriversConfiguration } from './ProjectDriversConfiguration';
import { ProjectDriversInputField, ProjectDriversValueField } from './ProjectDriversEntityField';
import {
  ProjectDriversReportCancelType,
  ProjectDriversReportCompleteType,
  ProjectDriversStopFieldsType,
  ProjectDriversTaskCancelType,
  ProjectDriversTaskCompleteType,
  ProjectDriversTaskType,
} from './ProjectDriversFields';

export interface ProjectDriversProps {
  configuration: ProjectDriversConfiguration[];
  stop_fields: Array<ProjectDriversValueField<ProjectDriversStopFieldsType>>;
  task_fields: Array<ProjectDriversValueField<ProjectDriversTaskType>>;
  task_completed_fields: Array<ProjectDriversInputField<ProjectDriversTaskCompleteType>>;
  task_canceled_fields: Array<ProjectDriversInputField<ProjectDriversTaskCancelType>>;
  stop_completed_fields: Array<ProjectDriversInputField<ProjectDriversReportCompleteType>>;
  stop_canceled_fields: Array<ProjectDriversInputField<ProjectDriversReportCancelType>>;
}

export class ProjectDrivers extends ValueObject<ProjectDriversProps> {
  get configuration() {
    return this.props.configuration;
  }

  set configuration(configuration: ProjectDriversConfiguration[]) {
    this.props.configuration = configuration;
  }

  get stop_fields() {
    return this.props.stop_fields;
  }

  set stop_fields(stop_fields: Array<ProjectDriversValueField<ProjectDriversStopFieldsType>>) {
    this.props.stop_fields = stop_fields;
  }

  get task_fields() {
    return this.props.task_fields;
  }

  set task_fields(task_fields: Array<ProjectDriversValueField<ProjectDriversTaskType>>) {
    this.props.task_fields = task_fields;
  }

  get task_completed_fields() {
    return this.props.task_completed_fields;
  }

  set task_completed_fields(task_completed_fields: Array<ProjectDriversInputField<ProjectDriversTaskCompleteType>>) {
    this.props.task_completed_fields = task_completed_fields;
  }

  get task_canceled_fields() {
    return this.props.task_canceled_fields;
  }

  set task_canceled_fields(task_canceled_fields: Array<ProjectDriversInputField<ProjectDriversTaskCancelType>>) {
    this.props.task_canceled_fields = task_canceled_fields;
  }

  get stop_completed_fields() {
    return this.props.stop_completed_fields;
  }

  set stop_completed_fields(stop_completed_fields: Array<ProjectDriversInputField<ProjectDriversReportCompleteType>>) {
    this.props.stop_completed_fields = stop_completed_fields;
  }

  get stop_canceled_fields() {
    return this.props.stop_canceled_fields;
  }

  set stop_canceled_fields(stop_canceled_fields: Array<ProjectDriversInputField<ProjectDriversReportCancelType>>) {
    this.props.stop_canceled_fields = stop_canceled_fields;
  }

  hasPinEnabled() {
    return this.props.configuration.includes(`pin`);
  }

  hasSurveyEnabled() {
    return this.props.configuration.includes(`survey`);
  }

  private constructor(props: ProjectDriversProps) {
    super(props);
  }

  static create(props: ProjectDriversProps): ProjectDrivers {
    return new ProjectDrivers(props);
  }
}
